/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useEffect } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import AtlaskitImage from '@atlaskit/image';
import { token, useThemeObserver } from '@atlaskit/tokens';

import { TEMPLATE_DETAILS, type TemplateDetails } from '../utils/templateDetails.tsx';

const ICONS: Record<string, TemplateDetails['icons']> = Object.values(TEMPLATE_DETAILS).reduce(
	(acc, { blueprintModuleCompleteKey, icons }) => ({ ...acc, [blueprintModuleCompleteKey]: icons }),
	{},
);
const DEFAULT_ICONS = TEMPLATE_DETAILS['Meeting notes'].icons;
const styles = cssMap({
	wrapper: {
		marginLeft: token('space.negative.100'),
	},
});
export const RevampedTemplateIcon = ({
	blueprintModuleCompleteKey,
	hovered,
}: {
	blueprintModuleCompleteKey: string;
	hovered: boolean;
}): JSX.Element => {
	const { colorMode } = useThemeObserver();
	const { dark, light } = ICONS[blueprintModuleCompleteKey] ?? DEFAULT_ICONS;
	const { hover, normal } = colorMode === 'dark' ? dark : light;

	useEffect(() => {
		// Preload to avoid flicker on hover
		const hoverImage = new Image();
		const normalImage = new Image();
		hoverImage.src = hover;
		normalImage.src = normal;
	}, [hover, normal]);

	return (
		<Box xcss={styles.wrapper}>
			<AtlaskitImage testId="revamped-template-icon" src={hovered ? hover : normal} alt="" />
		</Box>
	);
};
